(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["offhoo-nav-v2"] && !Shopify.designMode) return;
  try {
    (function initOffhooNavV2() {
    const root = document.querySelector('[data-offhoo-nav-v2]');
    if (!root || root.dataset.offhooNavV2Ready === 'true') return;
    root.dataset.offhooNavV2Ready = 'true';

    const allItem = root.querySelector('[data-offhoo-nav-v2-all]');
    const toggle = root.querySelector('[data-offhoo-nav-v2-toggle]');
    const flyout = root.querySelector('[data-offhoo-nav-v2-flyout]');
    if (!allItem || !toggle || !flyout) return;

    function clearTriggerFocus() {
      const active = document.activeElement;
      if (active instanceof HTMLElement && allItem.contains(active)) {
        active.blur();
      }
    }

    function getActivityAreaEl() {
      return (
        document.querySelector('#header-component .header__row--bottom .header__columns') ||
        document.querySelector('#header-component .header__columns') ||
        document.querySelector('.shopify-section .page-width') ||
        null
      );
    }

    // Align flyout to content/activity area; column width stays activity/3 even when L2/L3 hidden.
    function syncFlyoutGeometry() {
      const area = getActivityAreaEl();
      if (!area) return;

      const areaRect = area.getBoundingClientRect();
      const rootRect = root.getBoundingClientRect();
      const left = Math.round(areaRect.left - rootRect.left);
      const width = Math.round(areaRect.width);

      if (width > 0) {
        root.style.setProperty('--offhoo-nav-v2-flyout-left', `${left}px`);
        root.style.setProperty('--offhoo-nav-v2-activity-width', `${width}px`);
        root.style.setProperty('--offhoo-nav-v2-col-width', `${Math.round(width / 3)}px`);
      }
    }

    function setOpen(isOpen) {
      allItem.classList.toggle('is-open', isOpen);
      // Click-close while pointer still on trigger: suppress :hover until mouse leaves.
      if (isOpen) {
        allItem.classList.remove('is-force-closed');
        syncFlyoutGeometry();
      } else {
        if (allItem.matches(':hover')) {
          allItem.classList.add('is-force-closed');
        } else {
          allItem.classList.remove('is-force-closed');
        }
        // Avoid :focus leftover keeping the flyout open after mouse leaves.
        clearTriggerFocus();
      }
      syncExpanded();
    }

    function syncExpanded() {
      const blocked = allItem.classList.contains('is-force-closed');
      const expanded =
        allItem.classList.contains('is-open') || (!blocked && allItem.matches(':hover'));
      toggle.setAttribute('aria-expanded', String(expanded));
      if (expanded) syncFlyoutGeometry();
    }

    function activateL1(l1Index) {
      root.querySelectorAll('[data-offhoo-nav-v2-l1]').forEach((item) => {
        item.classList.toggle('is-active', item.dataset.l1Index === String(l1Index));
      });

      root.querySelectorAll('[data-offhoo-nav-v2-l2-panel]').forEach((panel) => {
        const match = panel.dataset.l1Index === String(l1Index);
        panel.classList.toggle('is-active', match);
        panel.hidden = !match;
      });

      // Show L2 only; keep L3 hidden until an L2 item with children is hovered.
      clearL3();
      root.querySelectorAll(`[data-offhoo-nav-v2-l2][data-l1-index="${l1Index}"]`).forEach((item) => {
        item.classList.remove('is-active');
      });
    }

    function clearL3() {
      root.querySelectorAll('[data-offhoo-nav-v2-l3-panel]').forEach((panel) => {
        panel.classList.remove('is-active');
        panel.hidden = true;
      });
    }

    function activateL2(l1Index, l2Index) {
      root.querySelectorAll(`[data-offhoo-nav-v2-l2][data-l1-index="${l1Index}"]`).forEach((item) => {
        item.classList.toggle('is-active', item.dataset.l2Index === String(l2Index));
      });

      let matched = false;
      root.querySelectorAll('[data-offhoo-nav-v2-l3-panel]').forEach((panel) => {
        const match =
          panel.dataset.l1Index === String(l1Index) && panel.dataset.l2Index === String(l2Index);
        panel.classList.toggle('is-active', match);
        panel.hidden = !match;
        if (match) matched = true;
      });

      if (!matched) clearL3();
    }

    allItem.addEventListener('mouseenter', () => {
      syncFlyoutGeometry();
      syncExpanded();
    });
    allItem.addEventListener('mouseleave', () => {
      allItem.classList.remove('is-force-closed');
      syncExpanded();
    });

    toggle.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      // If already visible via hover (or pinned), first click collapses.
      const visiblyOpen =
        allItem.classList.contains('is-open') ||
        (!allItem.classList.contains('is-force-closed') && allItem.matches(':hover'));
      setOpen(!visiblyOpen);
    });

    window.addEventListener('resize', () => {
      if (allItem.classList.contains('is-open') || allItem.matches(':hover')) {
        syncFlyoutGeometry();
      }
    });

    syncFlyoutGeometry();

    root.querySelectorAll('[data-offhoo-nav-v2-l1]').forEach((item) => {
      item.addEventListener('mouseenter', () => activateL1(item.dataset.l1Index));
      item.addEventListener('focusin', () => activateL1(item.dataset.l1Index));
    });

    root.querySelectorAll('[data-offhoo-nav-v2-l2]').forEach((item) => {
      const handler = () => {
        if (item.classList.contains('has-children')) {
          activateL2(item.dataset.l1Index, item.dataset.l2Index);
        } else {
          root
            .querySelectorAll(`[data-offhoo-nav-v2-l2][data-l1-index="${item.dataset.l1Index}"]`)
            .forEach((el) => el.classList.remove('is-active'));
          item.classList.add('is-active');
          clearL3();
        }
      };
      item.addEventListener('mouseenter', handler);
      item.addEventListener('focusin', handler);
    });

    document.addEventListener('click', (event) => {
      if (!allItem.contains(event.target)) setOpen(false);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      if (!allItem.classList.contains('is-open') && !allItem.matches(':hover')) return;
      setOpen(false);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["offhoo-taxonomy-menu"] && !Shopify.designMode) return;
  try {
    function closeOffhooDesktopMenus(exceptItem) {
    document.querySelectorAll('[data-offhoo-menu-item].is-open').forEach((item) => {
      if (item === exceptItem) return;

      item.classList.remove('is-open');
      item.querySelector('[data-offhoo-menu-toggle]')?.setAttribute('aria-expanded', 'false');
    });
  }

  function syncOffhooMobileDrawer(details) {
    if (!(details instanceof HTMLDetailsElement)) return;

    const isOpen = details.open;
    details.classList.toggle('menu-open', isOpen);
    details.querySelector('summary')?.setAttribute('aria-expanded', String(isOpen));
  }

  function closeOffhooMobileDrawer(details) {
    if (!(details instanceof HTMLDetailsElement)) return;

    details.open = false;
    syncOffhooMobileDrawer(details);
  }

  function scrollOffhooMobileCurrentIntoView(root) {
    const scope = root || document;
    const current =
      scope.querySelector(
        '.offhoo-taxonomy-menu__mobile-child-link.is-current, .offhoo-taxonomy-menu__mobile-grandchild-link.is-current, .offhoo-taxonomy-menu__mobile-link.is-current'
      ) ||
      scope.querySelector(
        '.offhoo-taxonomy-menu__mobile-link.is-child-current, .offhoo-taxonomy-menu__mobile-child-link.is-child-current'
      );

    if (!(current instanceof HTMLElement)) return;

    requestAnimationFrame(() => {
      current.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    });
  }

  document.addEventListener('toggle', (event) => {
    const details = event.target;
    if (!(details instanceof HTMLDetailsElement) || !details.hasAttribute('data-offhoo-mobile-drawer')) return;

    syncOffhooMobileDrawer(details);

    if (details.open) {
      scrollOffhooMobileCurrentIntoView(details);
    }
  });

  document.addEventListener('click', (event) => {
    const closeTrigger = event.target.closest('[data-offhoo-drawer-close]');

    if (closeTrigger) {
      const details = closeTrigger.closest('[data-offhoo-mobile-drawer]');
      closeOffhooMobileDrawer(details);
      return;
    }

    const desktopToggle = event.target.closest('[data-offhoo-menu-toggle]');

    if (desktopToggle) {
      const menuItem = desktopToggle.closest('[data-offhoo-menu-item]');
      const isOpen = menuItem?.classList.contains('is-open');

      closeOffhooDesktopMenus(menuItem);
      menuItem?.classList.toggle('is-open', !isOpen);
      desktopToggle.setAttribute('aria-expanded', String(!isOpen));
      return;
    }

    const mobileToggle = event.target.closest('[data-offhoo-mobile-toggle]');

    if (mobileToggle) {
      event.preventDefault();
      const panelId =
        mobileToggle.getAttribute('aria-controls') ||
        mobileToggle.getAttribute('data-offhoo-mobile-panel');
      const panel = document.getElementById(panelId);
      const isOpen = mobileToggle.getAttribute('aria-expanded') === 'true';
      const nextOpen = !isOpen;

      mobileToggle.setAttribute('aria-expanded', String(nextOpen));

      if (panel) {
        panel.hidden = !nextOpen;
      }

      // Keep title text from picking up sticky focus/active orange.
      if (mobileToggle instanceof HTMLElement) {
        mobileToggle.blur();
      }
      const active = document.activeElement;
      if (active instanceof HTMLElement && mobileToggle.contains(active)) {
        active.blur();
      }

      return;
    }

    if (!event.target.closest('[data-offhoo-menu-item]')) {
      closeOffhooDesktopMenus();
    }
  });

  document.addEventListener('keydown', (event) => {
    const rowToggle = event.target.closest('[data-offhoo-mobile-row][data-offhoo-mobile-toggle]');

    if (rowToggle && (event.key === 'Enter' || event.key === ' ')) {
      event.preventDefault();
      rowToggle.click();
      return;
    }

    if (event.key !== 'Escape') return;

    const openItem = document.querySelector('[data-offhoo-menu-item].is-open');
    closeOffhooDesktopMenus();
    openItem?.querySelector('[data-offhoo-menu-toggle]')?.focus();

    // Close drawer only; keep current-path accordion expansion for next open.
    document.querySelectorAll('[data-offhoo-mobile-drawer][open]').forEach((details) => {
      closeOffhooMobileDrawer(details);
    });
  });
  } catch(e) { console.error(e); }
})();

})();
